// Creator-Chat ships English + German only.
//
// Upstream Chatwoot imports all 40 locales here statically — each is its
// own ES module with 10-15 sub-imports (cannedMgmt.json, settings.json,
// etc.). In Vite dev mode every import is a separate HTTP request, so a
// single page load triggers ~600 requests. Through ngrok's free tier
// (4000 req/min) that hits the rate-limiter on a cold Vite cache and the
// whole page goes blank.
//
// We don't ship localized UI for the other 38 languages, so importing
// them is purely overhead. If you ever need to add a locale, import it
// here and add it to the export below.
import de from './locale/de';
import en from './locale/en';

export default {
  de,
  en,
};
